import { createTheme, useTheme } from "@material-ui/core/styles";
import { useMediaQuery } from "@material-ui/core";
import { CremaTheme } from "../../types/AppContextPropsType";
import { Breakpoint } from "@material-ui/core/styles/createBreakpoints";
import moment from "moment";
import { useIntl } from "react-intl";

type BreakpointOrNull = Breakpoint | null;

export const isBreakPointDown = (key: "xs" | "sm" | "md" | "lg" | "xl") => {
  const defaultTheme = createTheme();
  return defaultTheme.breakpoints.width(key) > window.innerWidth;
};

export const useDownBreakPointChecker = (
  key: "xs" | "sm" | "md" | "lg" | "xl"
) => {
  return useMediaQuery((theme: CremaTheme) => theme.breakpoints.down(key));
};

export const useBreakPointDown = (key: "xs" | "sm" | "md" | "lg" | "xl") => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(key));
};

export const useWidth = () => {
  const theme: CremaTheme = useTheme();
  const keys: Breakpoint[] = [...theme.breakpoints.keys].reverse();
  return (
    keys.reduce((output: BreakpointOrNull, key: Breakpoint) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matches = useMediaQuery(theme.breakpoints.up(key));
      return !output && matches ? key : output;
    }, null) || "xs"
  );
};

export const createRoutes = (routeConfigs: any[]) => {
  let allRoutes: any[] = [];
  routeConfigs.forEach((config) => {
    allRoutes = [...allRoutes, ...setRoutes(config)];
  });
  return allRoutes;
};

export const setRoutes = (config: any) => {
  let routes = [...config.routes];
  if (config.auth) {
    routes = routes.map((route) => {
      let auth = route.auth
        ? [...config.auth, ...route.auth]
        : [...config.auth];
      return { ...route, auth };
    });
  }

  return [...routes];
};
export const getBreakPointsValue = (valueSet: any, breakpoint: string) => {
  if (typeof valueSet === "number") return valueSet;
  switch (breakpoint) {
    case "xs":
      return valueSet.xs;
    case "sm":
      return valueSet.sm || valueSet.xs;
    case "md":
      return valueSet.md || valueSet.sm || valueSet.xs;
    case "lg":
      return valueSet.lg || valueSet.md || valueSet.sm || valueSet.xs;
    default:
      return (
        valueSet.xl || valueSet.lg || valueSet.md || valueSet.sm || valueSet.xs
      );
  }
};
export const getFileSize = (bytes: number) => {
  if (bytes === 0) return "0 Bytes";
  let k = 1024,
    dm = 2,
    sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const getCustomDateTime = (
  value: number = 0,
  unit: moment.unitOfTime.DurationConstructor = "days",
  format: string = "YYYY-MM-DD"
): string => {
  if (value === 0) {
    return moment().format(format);
  } else {
    return moment().add(value, unit).format(format);
  }
};

export const timeFromNow = (date: string) => {
  const timestamp = +moment(date).format("X");
  const newDate = moment.unix(timestamp);
  return moment(newDate).fromNow();
};

// 'intl' service singleton reference
let intl: any;

export function IntlGlobalProvider({ children }: any) {
  intl = useIntl();
  // Keep the 'intl' service reference
  return children;
}

export const appIntl = () => {
  return intl;
};
export const checkPermission = (
  routeAuth: any | null | undefined,
  userRole: any | null | undefined
) => {
  if (routeAuth === null || routeAuth === undefined) {
    return true;
  }

  if (userRole && Array.isArray(userRole)) {
    return routeAuth.some((r: any) => userRole.indexOf(r) >= 0);
  }

  if (routeAuth.length === 0) {
    return !userRole || userRole.length === 0;
  }
  if (userRole && Array.isArray(userRole) && Array.isArray(routeAuth)) {
    return routeAuth.some((r) => userRole.indexOf(r) >= 0);
  }
  return routeAuth.indexOf(userRole) >= 0;
};

export const getCurrentAge = (date: Date) => {
  return moment().diff(date, "years", false);
};

export const getCurrentAgeWithYearFormat = (data: string) => {
  let dateofbirth = yearFormat(data);
  let from = dateofbirth.split("-");
  // let birthdateTimeStamp:any = new Date(from[2], from[1] - 1, from[0]); // Atanu
  let birthdateTimeStamp = new Date(
    parseInt(from[2]),
    parseInt(from[1]) - 1,
    parseInt(from[0])
  );

  return getCurrentAge(birthdateTimeStamp);
};

// export const yearFormat=(date) =>{ //Atanu
export const yearFormat = (date: string) => {
  let str = date;
  if (str.length <= 10) {
    return date;
  } else {
    var x = new Date(date);
    var y = x.getFullYear().toString();
    var m = (x.getMonth() + 1).toString();
    var d = x.getDate().toString();
    d.length == 1 && (d = "0" + d);
    m.length == 1 && (m = "0" + m);

    var ddmmyyyy = d + "-" + m + "-" + y;

    return ddmmyyyy;
  }
};

// export function getFileExtension(filename) { //Atanu
export function getFileExtension(filename: string) {
  if (!filename) return "";

  const pathPart = filename.split(/[?#]/)[0];
  const url = pathPart.split("/").pop() || "";

  const match = url.match(/\.([a-z0-9]+)(?=_|$)/i);

  return match ? match[1].toLowerCase() : "";
}

const hasTimezoneInfo = (value: string) => /([zZ]|[+-]\d{2}:?\d{2})$/.test(value);

export const formatDateTimeLocal = (
  dateStr: string,
  formatStr: string = "DD-MM-YYYY hh:mm A"
) => {
  if (!dateStr || dateStr === "null" || dateStr === "undefined") return "";

  const value = dateStr.toString().trim();
  const parsed = hasTimezoneInfo(value) ? moment(value) : moment.utc(value);

  if (!parsed.isValid()) {
    return value;
  }

  return parsed.local().format(formatStr);
};
